import React, { Component } from 'react';
import logo from './logo.svg';
import Search from "./Homepage/Search";
import Categories from "./Homepage/Categories"
import Countries from "./Homepage/Countries";
import Banner from "./Homepage/Banner"
import './App.css';
import Homepage from "./Homepage/Homepage";
import SearchResults from "./SearchResults/SearchResults";
import SearchDetail from "./SearchDetail/SearchDetail";
import axios from 'axios';
import {
    BrowserRouter as Router,
    Route,
    Link,
    Switch,
    Redirect
} from 'react-router-dom'


var state;

class App extends Component {

    componentDidMount(){
        //alert(window.location.href)
        let url = new URL(window.location.href);

        let searchParams = new URLSearchParams(url.search);


        var okres = searchParams.get('okres');
        var zlava = searchParams.get('zlava');
        var kategoria = searchParams.get('kategoria');


        if(okres != null || zlava != null || kategoria != null) {

            var array = new Array();

            if(kategoria != null) {
                array.push(kategoria);
            }else{
                array.push("");
            }
            if(zlava!=null) {
                array.push(zlava);
            }else{
                array.push("");
            }
            array.push("");
            array.push("");
            if(okres != null) {
                array.push(okres);
            }
            else{
                array.push("");
            }

            this.setState({search: true});
            this.setState({detail: false});
            this.setState({definition: array});
        }







        let datas = [];

        axios.get(`https://mportalsystem2.btect.sk/api/getdistricts`)
            .then(res => {
                const data = res.data[0];
                this.setState({fetchdata: data});

                if(window.location.pathname != '/'){
                    let okres = window.location.pathname.replace('/','');




                    if(!isNaN(okres)){
                        var self = this;
                        axios.get('https://mportalsystem2.btect.sk/api/getlist/' + okres).then(data=> {

                            if (data.status == 200) {

                                self.setState({
                                    detail: true,
                                    id: okres,
                                });
                            }
                        }


                    )


                    }

                    this.state.fetchdata.find((element) => {
                        if(element.slug == okres){
                            this.setState({
                                search: true,
                                definition: element.id,
                            });
                        }
                    });





                }


            });






    }
    constructor(props) {
        super(props);
        this.state = {
            search: false,
            id: "",
            definition: "",
            detail: false,
            data: [],
            fetchdata: [],
            images:[],
        }
        axios.get(`https://mportalsystem2.btect.sk/api/pages/1`)
            .then(res => {
                const data = res.data[0];

                this.setState({ data: data });


            });

        axios.get(`https://mportalsystem2.btect.sk/api/pages/image/1`)
            .then(res => {
                const data = res.data[0];

                this.setState({ images: data });



            });
        this.setSearch1 = this.setSearch1.bind(this);
    }




    setSearch = () => {

        this.setState({search: !this.state.search});

    }
    setSearchFromDet = () => {
        this.setState({search: !this.state.search});
        this.setState({detail: !this.state.detail});
    }

    setNullDefinition = () =>{
        this.setState({definition: ""});
    }

    setSearchDefs = (defs) => {
        this.setState({search: true});
        this.setState({detail: false});
        this.setState({definition: defs});
    }

    setSearch1(){

        this.setState({search: true});
        this.setState({detail: false});
    }

    setDetail = (id) => {
        this.setState({id: id});
        this.setState({detail: !this.state.detail});
    }

    findSlug = (slug) => {
        let vysledok = this.state.data;

         this.state.data.map(data => {
                 if (data.slug == slug) {
                     vysledok = data.content;
                 }
             }
         );
         return vysledok;
    }
    findImageBySlug = (slug) => {
        let vysledok;


            if(this.state.images == ""){
                axios.get(`https://mportalsystem2.btect.sk/api/pages/image/1`)
                    .then(res => {
                        const data = res.data[0];
                        this.setState({ images: data });

                    })
            }



        this.state.images.map(data => {

                if (data.slug == slug) {



                        vysledok = data.path;
                }
            }
        );

        return vysledok;
    }

    findGroup = (group) => {

        let array = new Array();

        var obje = this.state.data.map(data => {
               if (data.groupa == group) {
                    array.push(data);
                }
            }
        );

        return array;
    }



  render() {

        if(this.state.detail == true){
            return (

                <div className="App">
                    <SearchDetail definition={this.state.definition} setSearchBack={this.setSearch1} setSearchDefs={this.setSearchDefs} setSearch={this.setSearchFromDet} id = {this.state.id} setDetail = {this.setDetail} />
                </div>

            );
        }
        if(this.state.search == false) {
            return (
                <div className="App">
                    <Homepage setnull={this.setNullDefinition} findImageBySlug={this.findImageBySlug} findGroup={this.findGroup} findSlug={this.findSlug} setSearchDefs={this.setSearchDefs} setSearch = {this.setSearch} />
                </div>
            );
        }
        else if(this.state.search == true){
            return(
                <div className="App">
                    <SearchResults definition={this.state.definition} setDetail={this.setDetail} setSearch={this.setSearch}/>
                </div>
            );
        }
  }
}

export default App;
